import LoginEmailForm from './form';

export default function LoginEmail() {
  return <LoginEmailForm />;
}
